/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED -- ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbButton as AbButtonImpl, convertButtonProps } from "abreact/misc/AbButton";
import * as React from "react";

/**
 * @deprecated in favor of AbButtonType from absdk/commons/ui/misc/AbButton
 */
export let AbButtonType = /*#__PURE__*/function (AbButtonType) {
  AbButtonType["DEFAULT"] = "";
  AbButtonType["PRIMARY"] = "ab-button-primary";
  AbButtonType["SUBMIT"] = "ab-button-submit";
  AbButtonType["SUCCESS"] = "ab-button-success";
  AbButtonType["INFO"] = "ab-button-info";
  AbButtonType["WARNING"] = "ab-button-warning";
  AbButtonType["DANGER"] = "ab-button-danger";
  AbButtonType["LINK"] = "ab-button-link";
  return AbButtonType;
}({});

/**
 * @deprecated in favor of AbButtonSize from absdk/commons/ui/misc/AbButton
 */
export let AbButtonSize = /*#__PURE__*/function (AbButtonSize) {
  AbButtonSize["DEFAULT"] = "";
  AbButtonSize["LARGE"] = "ab-button-large";
  AbButtonSize["SMALL"] = "ab-button-small";
  AbButtonSize["EXTRASMALL"] = "ab-button-mini";
  return AbButtonSize;
}({});

/**
 * Properties of the AbButton component.
 *
 * @deprecated
 */

/**
 * The **AbButton** component is a basic button that performs an action when clicked.
 *
 * [[include:abreact/public/core/AbButton.md]]
 *
 * @deprecated in favor of absdk/commons/ui/misc/AbButton
 */
export class AbButton extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(AbButtonImpl, convertButtonProps(this.props));
  }
}
//# sourceMappingURL=AbButton.js.map
